export default __webpack_public_path__ + "static/media/image23tum.265978d7.jpg";